import React, { useEffect, useRef, useContext, use } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { ContextBoard } from "../context/ContextBoard";

const PrivateRoute12 = ({ children, tokenKey = "tokenclassxii" }) => {
  const token = sessionStorage.getItem(tokenKey);
  const {
    setCandidateid12,
    setMode12,
    setDivyangcode12,
    setCastecode12,
    setClass12regulardata,
  } = useContext(ContextBoard);
  const location = useLocation();
  const navigate = useNavigate();
  const prevPath = useRef(location.pathname + location.search);

  useEffect(() => {
    const currentPath = location.pathname;
    const currentSearch = new URLSearchParams(location.search);
    const currentMode = currentSearch.get("mode");

    const prevURL = new URLSearchParams(prevPath.current.split("?")[1]);
    const prevPathname = prevPath.current.split("?")[0];
    const prevMode = prevURL.get("mode");

    // ✅ Case 1: Leaving regular-student/upload-document → clear all context
    if (
      (prevPathname === "/class-xii-regular-student-info" ||
        prevPathname === "/class-xii-upload-document") &&
      !(
        currentPath === "/class-xii-regular-student-info" ||
        currentPath === "/class-xii-upload-document"
      )
    ) {
      setCandidateid12("");
      setDivyangcode12("");
      setCastecode12("");
      setMode12("");
      setClass12regulardata(false);
    }
    if (
      (prevPathname === "/class-xii-correction-regular" ||
        prevPathname === "/class-xii-upload-document") &&
      !(
        currentPath === "/class-xii-correction-regular" ||
        currentPath === "/class-xii-upload-document"
      )
    ) {
      setCandidateid12("");
      setDivyangcode12("");
      setCastecode12("");
      setMode12("");
      setClass12regulardata(false);
    }

    // ✅ Case 2: Special case → upload-document → regular-student/add-ex-regular-student
    if (
      prevPathname === "/class-xii-upload-document" &&
      (currentPath === "/class-xii-regular-student-info" ||
        currentPath === "/class-xii-add-qualifying-info" ||
        currentPath === "/class-xii-add-improvement-info" ||
        currentPath === "/class-xii-add-ex-regular-info-jac")
    ) {
      setCandidateid12("");
      setDivyangcode12("");
      setCastecode12("");
      setMode12("");
      setClass12regulardata(false);
      navigate("/class-xii-dashboard");
    }
    if (
      prevPathname === "/class-xii-upload-document" &&
      (currentPath === "/class-xii-correction-regular" ||
        currentPath === "/class-xii-correction-exregular" ||
        currentPath === "/class-xii-correction-betterment" ||
        currentPath === "/class-xii-correction-qualify")
    ) {
      setCandidateid12("");
      setDivyangcode12("");
      setCastecode12("");
      setMode12("");
      setClass12regulardata(false);
      navigate("/class-xii-dashboard");
    }
    // if (
    //   currentPath !== "/class-x-upload-document" &&
    //   (prevPathname !== "/class-x-regular-student-info" ||
    //     prevPathname !== "/class-x-add-ex-regular-student" ||
    //     prevPathname !== "/class-x-improvement-info")
    // ) {
    //   setCandidateid10("");
    //   setDivyangcode10("");
    //   setCastecode10("");
    //   setMode10("");
    //   setClass10regulardata(false);
    // }
    prevPath.current = location.pathname + location.search;
  }, [location]);
  if (!token) {
    return <Navigate to="/class-xii" />;
  }

  return children;
};

export default PrivateRoute12;
